var map = {
	"./busd.svg": 1997,
	"./crypto-pending.png": 1998,
	"./crypto-reject.png": 1999,
	"./crypto-success.png": 2000,
	"./direpay.svg": 2001,
	"./trx.svg": 2002,
	"./usdc.svg": 2003,
	"./usdt.svg": 2004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;